import { getCustomCalendarValueFromEpoch, getDisplayString, } from '@thoughtspot/custom-calendar-service';
import { formatDate, formatDateNum, formatTimeOfDay, } from '@thoughtspot/date-format-util';
import { formatDataValue } from '@thoughtspot/number-format-util';
import _ from 'lodash';
import { CurrencyFormatType } from '../types/prism';
import { FormatterTypeEnum } from './types';
export function genericFormatter(dataValue, _options = {}) {
    return formatDataValue(dataValue, {
        checkOnlySpecialFormat: true,
    });
}
const numericFormatter = (dataValue, options = {}) => {
    const currencyTypeInfo = options.currencyTypeInfo;
    const currencyRef = options.columnToFormatPatternType &&
        Object.values(options.columnToFormatPatternType).indexOf('CURRENCY') !==
            -1;
    let isCurrency = currencyRef || (currencyTypeInfo && !!currencyTypeInfo.settingType);
    let currencyCode;
    if (isCurrency &&
        currencyTypeInfo.settingType !== CurrencyFormatType.UserLocale) {
        if (currencyTypeInfo.settingType === CurrencyFormatType.IsoCode) {
            currencyCode = currencyTypeInfo.isoCode;
        }
        else if (currencyRef) {
            if (Array.isArray(dataValue)) {
                currencyCode = dataValue[1];
                dataValue = dataValue[0];
            }
            else if (options.currencyCode) {
                currencyCode = options.currencyCode;
            }
            else {
                isCurrency = false;
            }
        }
        else {
            isCurrency = false;
        }
    }
    return formatDataValue(dataValue, {
        noShorten: false,
        formatPattern: options.formatPattern,
        isDouble: options.isDouble,
        isPercent: options.isPercent,
        nDecimal: options.nDecimal,
        isCurrency,
        currencyCode,
    });
};
export const geoFormatter = (dataValue) => {
    return `${dataValue}`;
};
export function dateFormatter(dataValue, options, firstXAxisColumn) {
    options = _.merge({}, options, {
        customCalendarOverridesFiscalOffset: firstXAxisColumn.customCalendarOverridesFiscalOffset,
        formatPattern: firstXAxisColumn.formatPattern,
        showFinancialFormat: firstXAxisColumn.showFinancialFormat,
        hasCustomCalendar: firstXAxisColumn.hasCustomCalendar,
        displayToCustomCalendarValueMap: firstXAxisColumn.displayToCustomCalendarValueMap,
    });
    const customCalendarValueFromEpoch = getCustomCalendarValueFromEpoch(dataValue, options);
    if (customCalendarValueFromEpoch &&
        getDisplayString(customCalendarValueFromEpoch)) {
        return getDisplayString(customCalendarValueFromEpoch);
    }
    return formatDate(dataValue, options.formatPattern, !options.showFinancialFormat, options);
}
export function dateNumFormatter(dataValue, options, firstXAxisColumn) {
    options = _.merge({}, options, {
        customCalendarOverridesFiscalOffset: firstXAxisColumn.customCalendarOverridesFiscalOffset,
        formatPattern: firstXAxisColumn.formatPattern,
        showFinancialFormat: firstXAxisColumn.showFinancialFormat,
        hasCustomCalendar: firstXAxisColumn.hasCustomCalendar,
        displayToCustomCalendarValueMap: firstXAxisColumn.displayToCustomCalendarValueMap,
    });
    const customCalendarValueFromEpoch = getCustomCalendarValueFromEpoch(dataValue, options);
    if (customCalendarValueFromEpoch &&
        getDisplayString(customCalendarValueFromEpoch)) {
        return getDisplayString(customCalendarValueFromEpoch);
    }
    return formatDateNum(firstXAxisColumn.effectiveDataType, dataValue, options.formatPattern);
}
export function timeFormatter(dataValue, column) {
    const formatPattern = column.formatPattern || 'HH:mm:ss';
    return formatTimeOfDay(dataValue, formatPattern);
}
const typeToFormatterMap = {
    [FormatterTypeEnum.GENERIC_FORMATTER]: genericFormatter,
    [FormatterTypeEnum.NUMERIC_FORMATTER]: numericFormatter,
    [FormatterTypeEnum.GEO_FORMATTER]: geoFormatter,
    [FormatterTypeEnum.DATE_FORMATTER]: dateFormatter,
    [FormatterTypeEnum.DATE_NUM_FORMATTER]: dateNumFormatter,
    [FormatterTypeEnum.TIME_FORMATTER]: timeFormatter,
};
export function getFormatterOfTypeEnum(type) {
    return typeToFormatterMap[type];
}
export const INFINITY_SYMBOL = {
    COLOR_AXIS_POSITIVE: ' ',
    COLOR_AXIS_NEGATIVE: ' ',
    Y_AXIS_POSITIVE: '↑',
    Y_AXIS_NEGATIVE: '↓',
    X_AXIS_POSITIVE: '→',
    X_AXIS_NEGATIVE: '←',
};
export const INFINITY_HTML = '<span style="font-weight:bold">{1}∞ {2}</span>';
export const shouldOmitYear = (minDate, maxDate) => {
    const format = 'yyyy';
    const minYear = formatDate(minDate, format);
    const maxYear = formatDate(maxDate, format);
    return minYear === maxYear;
};
//# sourceMappingURL=formatter-util.js.map